var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.tryPlayMusic}},[_c('audio',{ref:"audio",attrs:{"src":_vm.audioSrc,"autoplay":""}}),(_vm.playError)?_c('p',[_vm._v("Klik di sini untuk memutar musik.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }